module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/logos/logo-sunkissed-6cf702f0894507187144513f6d8fc18f.svg";